<template>
  <v-container fluid>
    <v-dialog 
      v-model = "createKeyDialog" 
      width="500">
      <v-card>
        <v-card-title
          class="headline"
          primary-title>
          Add Key
        </v-card-title>
        <v-card-text>
          <v-form ref = "addFormRef">
          	<v-text-field
          	  v-model = "input.key"
          	  :rules = "[v => !!v || 'This field is required.']"
          	  placeholder = "Key"
          	  outline />
          	<v-text-field
          	  v-model = "input.endpoint_url"
          	  :rules = "[v => !!v || 'This field is required.']"
          	  placeholder = "Endpoint URL"
          	  outline />
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createKeyDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="addNewKey">
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model = "deleteKeyDialog" 
      width="400">
      <v-card v-if = "toBeDeleted">
        <v-card-title
          class="headline"
          primary-title>
          Delete {{ toBeDeleted.subscription_key }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this key?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="error"
            outline
            @click="deleteKeys">
            Delete
          </v-btn>
          <v-btn
            color = "black"
            class = "white--text"
            @click="deleteKeyDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout 
      row 
      wrap>
      <h1>Configure Keys</h1>
      <v-spacer />
      <app-actions />
    </v-layout>
    <v-flex xs12>
      <v-card class = "card-curvey">
      	<v-layout 
          row 
          wrap>
          <v-spacer />
          <v-btn
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog">
            <v-icon>add</v-icon>
            Add Key
          </v-btn>

        </v-layout>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="keys"
            item-key="subscription_key"
            no-data-text = "No Keys Available"
            :pagination.sync="$store.state.settings.pagination"
            class="elevation-1 nlp-data-table">
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr>
                <td>{{ props.item.subscription_key }}</td>
                <td>{{ props.item.endpoint_url }}</td>
                <td class="text-right"> <v-icon color = "error" class ="pointer-cursor" @click = "openDeleteDialog(props.item)">delete</v-icon></td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
        </v-layout>
  </v-container>
</template>

<script>
import AppActions from '../common/AppActions'
export default {
  name: 'AppKeys',
  components: {
    AppActions
  },
  data() {
    return {
      input: {
      	key: '',
      	endpoint_url: ''
      },
      keys: [],
      deleteKeyDialog: false,
      createKeyDialog: false,
      toBeDeleted: null,
      headers: [
        {
          text: 'Key',
          align: 'left',
          sortable: true,
          value: 'key'
        },
        {
          text: 'Endpoint URL',
          value: 'endpoint_url'
        },
        {
          text: '',
          value: 'id'
        },
      ]
    }
  },
  mounted() {
    // get keys
    this.getKeys()
  },
  methods: {
    getKeys(callback = null) {
      this.$store.dispatch('setLoader', true)
      this.$http_nlp.get(`/apps/${this.$route.params.id}/keys`).then(res=> {
      	this.keys = res.data.data
      	this.$store.dispatch('setLoader', false)
      }).catch(()=>{
      	this.$store.dispatch('setLoader', false)
      	this.$store.dispatch('setErrorMessage', true)
      })
    },
    openAddDialog(reset = true) {
      this.createKeyDialog = true
    },
    addNewKey() {
      // add key
      this.$store.dispatch('setLoader', true)
      if (this.$refs.addFormRef.validate()) {
          this.$http_nlp.post(`/apps/${this.$route.params.id}/keys`, this.input).then(res => {
          	this.$store.dispatch('setLoader', false)
          	this.createKeyDialog = false
          	this.$store.dispatch('setSnackbar', {
	            text: `Key Added Successfully`,
	            color: 'success'
	          })
    	      this.input = {
    		      key: '',
    		      endpoint_url: ''
    		    }
          	this.getKeys()
          }).catch((err)=>{
          	if(err && err.response && err.response.status === 400 && err.response.data && err.response.data.error)
	      		this.$store.dispatch('setErrorMessage', err.response.data.error)
	      	else this.$store.dispatch('setErrorMessage', true)
		      	this.$store.dispatch('setLoader', false)
	      })
      } else {
      	this.$store.dispatch('setLoader', false)
      	this.$store.dispatch('setErrorMessage', 'Invalid Input.')
      }
    },
    openDeleteDialog(key) {
    	this.toBeDeleted = key
    	this.deleteKeyDialog = true
    },
    deleteKeys() {
      this.$store.dispatch('setLoader', true)
      this.$http_nlp.delete(`/apps/${this.$route.params.id}/keys/${this.toBeDeleted.subscription_key}`).then(res => {
      	this.deleteKeyDialog = false
      	this.$store.dispatch('setLoader', false)
      	this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
        })
        this.getKeys()
      }).catch((err)=>{
      	this.$store.dispatch('setLoader', false)
      	if(err && err.response && err.response.status === 400)
      		this.$store.dispatch('setErrorMessage', err.response.data.error)
      	else this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="scss" src="../../../assets/sass/commponents/nlp.scss">
</style>
